import * as React from 'react';

import CrosshairRegion32 from './CrosshairRegion32';

export const crosshairRegion32 = () => <CrosshairRegion32 />;

export default {
    title: 'Icon/Line/CrosshairRegion32',
    component: CrosshairRegion32,
    parameters: {
        notes: "`import CrosshairRegion32 from 'box-ui-elements/es/icon/line/CrosshairRegion32';`",
    },
};
